export const toCampaignFileError = (error: unknown, message: string) => {
  if (error instanceof Error) {
    return error
  }

  const campaignFileError = new Error(message)

  if (error && typeof error === 'object') {
    Object.assign(campaignFileError, error)
  }

  return campaignFileError
}
